import './Work.css';
import { useState } from 'react';
import { createPortal } from 'react-dom';

const images = require.context('../../../media/Art', false, /\.(png|jpe?g|gif|webp|svg)$/);
const imageList = images.keys().map(images);

function Art() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openImage = (index) => setSelectedIndex(index);
  const closeImage = () => setSelectedIndex(null);

  const prev = (e) => {
    e.stopPropagation();
    setSelectedIndex((selectedIndex - 1 + imageList.length) % imageList.length);
  };

  const next = (e) => {
    e.stopPropagation();
    setSelectedIndex((selectedIndex + 1) % imageList.length);
  };

  return (
    <section className="gallery">
      <h2>Personal Art</h2>
      <div className="gallery-grid">
        {imageList.map((image, index) => (
          <img key={index} src={image} alt={`Art ${index}`} className="gallery-image" onClick={() => openImage(index)} loading='lazy'/>
        ))}
      </div>

      {selectedIndex !== null && createPortal(
        <div className="lightbox" onClick={closeImage}>
          <button className="lightbox-close" onClick={closeImage}>✕</button>
          <button className="lightbox-arrow left" onClick={prev}>‹</button>
          <img src={imageList[selectedIndex]} alt="selected" onClick={(e) => e.stopPropagation()} loading='lazy'/>
          <button className="lightbox-arrow right" onClick={next}>›</button>
        </div>,
        document.body
      )}
    </section>
  );
}
export default Art;